import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

export const useIsPrivacyModeEligible = (): boolean => {
	const { edition } = useSessionData();
	return edition === ConfluenceEdition.PREMIUM;
};
